module.exports = __webpack_public_path__ + "media/images/page/monthly_ic-6114ca67c6d5a35a28a883a53e162c7b.svg";